{
  "nav": {
    "home": "Startseite",
    "mobileHomes": "Mobilheime",
    "products": "Weitere Produkte",
    "about": "Über uns",
    "contact": "Kontakt",
    "blog": "Blog",
    "enquire": "Jetzt anfragen",
    "openMenu": "Menü öffnen",
    "closeMenu": "Menü schließen"
  },
  "common": {
    "readMore": "Mehr lesen",
    "submit": "Senden",
    "cancel": "Abbrechen",
    "loading": "Wird geladen...",
    "error": "Ein Fehler ist aufgetreten",
    "success": "Erfolg",
    "search": "Suche",
    "title": "Übersetzungsbeispiel",
    "examples": "Übersetzungsbeispiele",
    "key": "Schlüssel",
    "translation": "Übersetzung",
    "currentLanguage": "Aktuelle Sprache"
  },
  "contact": {
    "loading": "Kontaktinformationen werden geladen...",
    "title": "Kontakt",
    "intro": "Haben Sie ein Projekt im Sinn? Senden Sie uns eine Anfrage, und wir werden uns bei Ihnen melden.",
    "enquireNow": "Jetzt anfragen",
    "generalEnquiries": "Allgemeine Anfragen",
    "salesEnquiries": "Verkaufsanfragen",
    "followUs": "Folgen Sie uns",
    "ourOffice": "Unser Büro",
    "viewMap": "Karte ansehen",
    "ourFactory": "Unsere Fabrik",
    "address": {
      "full": "Temes u. 18, 3528 Miskolc, UNGARN",
      "label": "Adresse"
    },
    "phone": {
      "number": "(+381) 69 220 7072",
      "label": "Telefon"
    },
    "officeDescription": "Mit umfangreichen Erfahrungen in der Gastronomie und im Kundenservice ist unser Team bestrebt, von Anfang bis Ende ein nahtloses Erlebnis zu bieten.",
    "factoryDescription": "Unsere Fabrik befindet sich im Kontaktzentrum in Miskolc und ist mit der neuesten Fertigungstechnologie ausgestattet, um hochwertige modulare Häuser und Strukturen zu liefern.",
    "name": "Name",
    "email": "E-Mail",
    "message": "Nachricht",
    "formPhone": "Telefon",
    "formAddress": "Adresse",
    "send": "Nachricht senden"
  },
  "enquiry": {
    "formTitle": "Anfrageformular",
    "generalEnquiry": "Allgemeine Anfrage",
    "specificProduct": "Wenn Sie eine spezifische Anfrage zu einem Produkt haben, besuchen Sie bitte die Produktseite, um Ihre Anfrage zu stellen.",
    "privacyConsent": "Ich stimme der Verarbeitung meiner persönlichen Daten gemäß der Datenschutzrichtlinie zu *"
  },
  "home": {
    "featuredHomes": {
      "natura": {
        "name": "Natura",
        "description": "Umweltfreundlich, Moderner Komfort"
      },
      "sensa": {
        "name": "Sensa",
        "description": "Weitläufige Aussichten, Offenes Wohnen"
      }
    },
    "hero": {
      "title": "Premium-Wohnen, wohin Sie auch gehen",
      "subtitle": "Entdecken Sie unsere Auswahl an Premium-Mobilheimen und -Produkten"
    },
    "intro": "Willkommen bei MZM Homes, wo innovatives Design auf nachhaltige Konstruktion trifft.",
    "intro2": "Wir nutzen die Kraft der Offsite-Fertigung, um maßgeschneiderte modulare Häuser und andere Projekte zu liefern.",
    "mobileHomes": {
      "title": "Mobilheime",
      "description": "Entdecken Sie unsere Kollektion von fachmännisch gefertigten modularen Häusern, die für Komfort, Stil und Flexibilität konzipiert sind. Diese Häuser sind so gebaut, dass sie zu jedem Lebensstil passen und bieten luxuriöses Wohnen mit der Freiheit, dorthin zu gehen, wohin das Leben Sie führt."
    },
    "otherProducts": {
      "title": "Weitere Produkte",
      "description": "Entdecken Sie unsere Auswahl an anpassungsfähigen Strukturen, einschließlich Garagen, Carports, Containern und Terrassen, die entworfen wurden, um jedes Haus zu ergänzen. Jedes Produkt kombiniert Haltbarkeit und Stil und schafft funktionale Räume."
    },
    "featuredProducts": {
      "garages": {
        "name": "Garagen",
        "description": "Langlebige, stilvolle Lösungen zum Schutz Ihrer Fahrzeuge und zur Verbesserung Ihres Grundstücks."
      },
      "carports": {
        "name": "Carports",
        "description": "Freiluft-Fahrzeugschutzlösungen, die Haltbarkeit mit Zugänglichkeit verbinden."
      },
      "containers": {
        "name": "Container",
        "description": "Entdecken Sie unsere vielseitigen Containerlösungen, die für Haltbarkeit und endlose Möglichkeiten konzipiert sind."
      },
      "outdoorKitchens": {
        "name": "Außenküchen",
        "description": "Verwandeln Sie Ihren Außenbereich mit unseren stilvollen und funktionalen Außenküchenlösungen."
      },
      "garbageBins": {
        "name": "Mülltonnen",
        "description": "Praktische und stilvolle Lösungen für die Abfallentsorgung."
      }
    },
    "testimonials": {
      "title": "Kundengeschichten",
      "description": "Unser Engagement für Qualität und persönlichen Service hat einen bleibenden Eindruck hinterlassen. Entdecken Sie, wie unsere modularen Häuser und Strukturen ihre Wohnräume verändert und ihren Lebensstil verbessert haben."
    },
    "loading": "Wird geladen",
    "enquireNow": "Jetzt anfragen"
  },
  "products": {
    "loading": "Produkte werden geladen...",
    "title": "Weitere Produkte",
    "description": "Entdecken Sie unsere Auswahl an anpassungsfähigen Strukturen, einschließlich Garagen, Carports, Containern und Terrassen, die entworfen wurden, um jedes Haus zu ergänzen. Jedes Produkt kombiniert Haltbarkeit und Stil und schafft funktionale Räume.",
    "viewAll": "Alle anzeigen",
    "noProducts": "Derzeit sind keine Produkte verfügbar. Bitte schauen Sie später wieder vorbei.",
    "categoriesTitle": "Produktkategorien",
    "categoriesObject": {
      "title": "Produktkategorien",
      "list": {
        "garagesCarports": {
          "name": "Garagen & Carports",
          "description": "Langlebige, stilvolle Lösungen zum Schutz Ihrer Fahrzeuge und zur Verbesserung Ihres Grundstücks. Diese Strukturen bieten die perfekte Mischung aus Sicherheit und Eleganz und sind sowohl funktional als auch ästhetisch ansprechend."
        },
        "containers": {
          "name": "Container",
          "description": "Entdecken Sie unsere vielseitigen Containerlösungen, die für Haltbarkeit und endlose Möglichkeiten konzipiert sind. Ob für Lagerung, Transport oder individuelle Projekte, unsere Container bieten zuverlässige, flexible Optionen, um Ihre einzigartigen Bedürfnisse zu erfüllen."
        },
        "outdoorKitchens": {
          "name": "Außenküchen",
          "description": "Verwandeln Sie Ihren Außenbereich mit unseren stilvollen und funktionalen Außenküchenlösungen. Perfekt, um Gäste zu unterhalten oder Familienmahlzeiten an der frischen Luft zu genießen."
        },
        "garbageBins": {
          "name": "Mülltonnen",
          "description": "Praktische und stilvolle Lösungen für die Abfallentsorgung. Unsere Mülltonnenverkleidungen halten Ihren Außenbereich ordentlich und ergänzen gleichzeitig die Ästhetik Ihres Hauses."
        }
      }
    },
    "details": "Produktdetails",
    "specifications": "Spezifikationen",
    "categories": {
      "garages": {
        "name": "Garagen",
        "description": "Langlebige, stilvolle Lösungen zum Schutz Ihrer Fahrzeuge und zur Verbesserung Ihres Grundstücks. Diese Strukturen bieten die perfekte Mischung aus Sicherheit und Eleganz und sind sowohl funktional als auch ästhetisch ansprechend."
      },
      "carports": {
        "name": "Carports",
        "description": "Freiluft-Fahrzeugschutzlösungen, die Haltbarkeit mit Zugänglichkeit verbinden. Unsere Carports bieten zuverlässigen Schutz für Ihre Fahrzeuge und integrieren sich nahtlos in Ihr Grundstück."
      },
      "containers": {
        "name": "Container",
        "description": "Entdecken Sie unsere vielseitigen Containerlösungen, die für Haltbarkeit und endlose Möglichkeiten konzipiert sind. Ob für Lagerung, Transport oder individuelle Projekte, unsere Container bieten zuverlässige, flexible Optionen, um Ihre einzigartigen Bedürfnisse zu erfüllen."
      },
      "outdoorKitchens": {
        "name": "Außenküchen",
        "description": "Verwandeln Sie Ihren Außenbereich mit unseren stilvollen und funktionalen Außenküchenlösungen. Perfekt, um Gäste zu unterhalten oder Familienmahlzeiten an der frischen Luft zu genießen."
      },
      "garbageBins": {
        "name": "Mülltonnen",
        "description": "Praktische und stilvolle Lösungen für die Abfallentsorgung. Unsere Mülltonnenverkleidungen halten Ihren Außenbereich ordentlich und ergänzen gleichzeitig die Ästhetik Ihres Hauses."
      }
    },
    "categoryDetails": {
      "garagesCarports": {
        "name": "Garagen & Carports",
        "description": "Langlebige, stilvolle Lösungen zum Schutz Ihrer Fahrzeuge und zur Verbesserung Ihres Grundstücks. Diese Strukturen bieten die perfekte Mischung aus Sicherheit und Eleganz und sind sowohl funktional als auch ästhetisch ansprechend."
      },
      "containers": {
        "name": "Container",
        "description": "Entdecken Sie unsere vielseitigen Containerlösungen, die für Haltbarkeit und endlose Möglichkeiten konzipiert sind. Ob für Lagerung, Transport oder individuelle Projekte, unsere Container bieten zuverlässige, flexible Optionen, um Ihre einzigartigen Bedürfnisse zu erfüllen."
      },
      "outdoorKitchens": {
        "name": "Außenküchen",
        "description": "Verwandeln Sie Ihren Außenbereich mit unseren stilvollen und funktionalen Außenküchenlösungen. Perfekt, um Gäste zu unterhalten oder Familienmahlzeiten an der frischen Luft zu genießen."
      },
      "garbageBins": {
        "name": "Mülltonnen",
        "description": "Praktische und stilvolle Lösungen für die Abfallentsorgung. Unsere Mülltonnenverkleidungen halten Ihren Außenbereich ordentlich und ergänzen gleichzeitig die Ästhetik Ihres Hauses."
      }
    },
    "garages": {
      "garage6x3": {
        "name": "Garage 6x3",
        "description": "Kompakte und funktionale Garage für ein einzelnes Fahrzeug"
      },
      "garage6x6": {
        "name": "Garage 6x6",
        "description": "Geräumige Garagenlösung für mehrere Fahrzeuge"
      },
      "garageWithCarport": {
        "name": "Garage mit Carport",
        "description": "Kombinierte Lösung mit geschlossener Garage und angeschlossenem Carport"
      }
    },
    "carports": {
      "carport6x3": {
        "name": "Carport 6x3",
        "description": "Freiluft-Fahrzeugschutz mit langlebiger Konstruktion"
      },
      "carport6x6": {
        "name": "Carport 6x6",
        "description": "Geräumiger Freiluft-Unterstand für mehrere Fahrzeuge"
      }
    },
    "containers": {
      "basic": {
        "name": "BASIC Container",
        "description": "Einfache, langlebige Lagerlösung für verschiedene Bedürfnisse"
      },
      "premium": {
        "name": "PREMIUM Container",
        "description": "Verbesserter Container mit zusätzlichen Funktionen und überlegener Qualität"
      }
    },
    "outdoorKitchens": {
      "basic": {
        "name": "BASIC Außenküche",
        "description": "Einfache und funktionale Außenküchenlösung"
      },
      "premium": {
        "name": "PREMIUM Außenküche",
        "description": "Luxuriöse Außenküche mit Premium-Funktionen"
      }
    },
    "garbageBins": {
      "basic": {
        "name": "BASIC Mülltonnenlagerung",
        "description": "Einfache und funktionale Mülltonnenlösung"
      },
      "premium": {
        "name": "PREMIUM Mülltonnenlagerung",
        "description": "Verbesserte Mülltonnenlösung mit Premium-Funktionen"
      }
    },
    "items": {
      "garage6x3": {
        "name": "Garage 6x3",
        "description": "Kompakte und funktionale Garage für ein einzelnes Fahrzeug"
      },
      "garage6x6": {
        "name": "Garage 6x6",
        "description": "Geräumige Garagenlösung für mehrere Fahrzeuge"
      },
      "garageWithCarport": {
        "name": "Garage mit Carport",
        "description": "Kombinierte Lösung mit geschlossener Garage und angeschlossenem Carport"
      },
      "basicContainer": {
        "name": "BASIC Container",
        "description": "Einfache, langlebige Lagerlösung für verschiedene Bedürfnisse"
      },
      "premiumContainer": {
        "name": "PREMIUM Container",
        "description": "Verbesserter Container mit zusätzlichen Funktionen und überlegener Qualität"
      },
      "basicKitchen": {
        "name": "BASIC Außenküche",
        "description": "Einfache und funktionale Außenküchenlösung"
      },
      " premiumKitchen": {
        "name": "PREMIUM Außenküche",
        "description": "Luxuriöse Außenküche mit Premium-Funktionen"
      },
      "basicBin": {
        "name": "BASIC Mülltonnenlagerung",
        "description": "Einfache und funktionale Mülltonnenlösung"
      },
      "premiumBin": {
        "name": "PREMIUM Mülltonnenlagerung",
        "description": "Verbesserte Mülltonnenlösung mit Premium-Funktionen"
      }
    }
  },
  "about": {
    "loading": "Über uns Seite wird geladen...",
    "title": "Über uns",
    "whoWeAre": "Wer wir sind",
    "jumpTo": "Springen zu",
    "meetTheTeam": "Treffen Sie das Team",
    "team": "Unser Team",
    "history": "Unsere Geschichte",
    "mission": "Unsere Mission",
    "part1": {
      "title": "MZM Homes wurde 2024 von Menschen gegründet, die Design, Innovation und Nachhaltigkeit schätzen.",
      "description": "Als einer der führenden Experten Sloweniens im Bereich Offsite-Bau verbringen wir mehr Zeit damit, darüber nachzudenken, wie wir besser, intelligenter und schneller bauen können."
    },
    "part2": {
      "title": "Unser Ansatz nutzt die neueste Fertigungstechnologie, um Präzision, Haltbarkeit und einen deutlich reduzierten ökologischen Fußabdruck zu gewährleisten.",
      "description": "Wir setzen auch auf lokale Materialien und Lieferanten, um außergewöhnliche Lösungen zu liefern, die nachhaltig sind."
    },
    "part3": {
      "title": "Jedes MZM Homes-Projekt ist das Ergebnis eines einzigartigen und bewährten Ansatzes, der in mehr als 100 abgeschlossenen Häusern und anderen Strukturen demonstriert wurde",
      "description": "Unser schlüsselfertiger Service und unser transparentes Preismodell ermöglichen einen reibungslosen Übergang vom Zeichenbrett bis zur Haustür und machen die Reise so nahtlos wie transformativ."
    }
  },
  "blog": {
    "latestPosts": "Neueste Beiträge",
    "readMore": "Mehr lesen",
    "postedOn": "Veröffentlicht am"
  },
  "footer": {
    "salesEnquiries": "Vertriebsanfragen",
    "generalEnquiries": "Allgemeine Anfragen",
    "followUs": "Folgen Sie uns",
    "office": "MZM Büro",
    "factory": "MZM Fabrik",
    "pages": "Seiten",
    "products": "Produkte",
    "homePage": "Startseite",
    "garages": "Garagen",
    "carports": "Carports",
    "containers": "Container",
    "kitchens": "Küchen",
    "garbageBins": "Mülltonnen",
    "rights": "Alle Rechte vorbehalten",
    "copyright": "© {year} MZM Homes. Alle Rechte vorbehalten.",
    "sitemap": "Sitemap",
    "privacy": "Datenschutzrichtlinie",
    "terms": "Nutzungsbedingungen",
    "cookies": "Cookie-Richtlinie",
    "social": {
      "instagram": "Instagram",
      "linkedin": "LinkedIn",
      "facebook": "Facebook"
    }
  },
  "homes": {
    "loading": "Hausmodelle werden geladen...",
    "gallery": {
      "loading": "Bilder werden geladen..."
    },
    "title": "Mobilheime",
    "description": "Unsere exklusive Kollektion von vier fachmännisch entworfenen Hausmodellen, die jeweils eine einzigartige Mischung aus Stil, Funktionalität und Handwerkskunst bieten. Von umweltfreundlichen Innovationen bis hin zu geräumigen, luxuriösen Wohnräumen sind unsere Häuser auf vielfältige Geschmäcker und Lebensstile zugeschnitten.",
    "error": {
      "title": "Hoppla! Etwas ist schiefgelaufen",
      "message": "Wir konnten die von Ihnen gesuchten Hausmodelle nicht finden.",
      "backButton": "Zurück zur Startseite"
    },
    "naturaLine": {
      "title": "Natura Linie",
      "description": "Einführung der Natura Linie—wo Nachhaltigkeit auf modernen Luxus trifft. Entworfen mit umweltbewussten Materialien und energieeffizienten Funktionen, bieten diese Häuser eine perfekte Balance aus Stil, Komfort und Umweltverantwortung."
    },
    "sensaLine": {
      "title": "Sensa Linie",
      "description": "Einführung der Sensa Linie—erhöhen Sie Ihr Wohnerlebnis mit geräumigen, offenen Designs und atemberaubenden Aussichten. Diese Häuser kombinieren zeitgenössische Eleganz mit Funktionalität und schaffen die perfekte Umgebung für modernes Wohnen."
    },
    "noResults": "Keine Hausmodelle gefunden. Bitte schauen Sie später wieder vorbei.",
    "models": {
      "naturaMini": {
        "name": "Natura Mini",
        "description": "Umweltfreundliches Design mit modernem Komfort und Energieeffizienz.",
        "longDescription": "Das Natura Mini ist unser Flaggschiff unter den umweltfreundlichen Häusern, das mit Blick auf Nachhaltigkeit entworfen wurde, ohne Kompromisse bei Komfort oder Stil einzugehen. Mit energieeffizienten Systemen, nachhaltigen Materialien und intelligenter Haustechnik repräsentiert dieses Modell die Zukunft des verantwortungsvollen Wohnens. Der offene Grundriss schafft ein geräumiges Gefühl und maximiert gleichzeitig die Nutzung von natürlichem Licht."
      },
      "naturaMaxi": {
        "name": "Natura Maxi",
        "description": "Erweitertes umweltfreundliches Haus mit zusätzlichem Platz für Familien.",
        "longDescription": "Das Natura Maxi ist unser größeres umweltfreundliches Haus, das zusätzlichen Platz für Familien bietet und gleichzeitig das gleiche Engagement für Nachhaltigkeit und Qualität beibehält. Mit mehr Schlafzimmern und Wohnraum ist dieses Modell perfekt für diejenigen, die zusätzlichen Platz benötigen, ohne Kompromisse bei Umweltwerten einzugehen."
      },
      "sensaMini": {
        "name": "Sensa Mini",
        "description": "Geräumiges Design mit großen Fenstern für atemberaubende Aussichten.",
        "longDescription": "Das Sensa Mini ist darauf ausgelegt, Ihre Verbindung mit der umgebenden Umgebung durch seine expansiven Fenster und offenen Wohnräume zu maximieren. Perfekt für malerische Orte, bringt dieses Haus die Natur ins Innere und bietet gleichzeitig allen Komfort des modernen Wohnens. Luxuriöse Oberflächen und durchdachte Designelemente schaffen eine anspruchsvolle und dennoch gemütliche Atmosphäre."
      },
      "sensaMaxi": {
        "name": "Sensa Maxi",
        "description": "Unser größtes Panorama-Haus mit Premium-Funktionen und Platz.",
        "longDescription": "Das Sensa Maxi ist unser geräumigstes Modell und bietet expansive Wohnbereiche und Premium-Funktionen. Mit seinen großen Fenstern und dem offenen Design schafft dieses Haus eine nahtlose Verbindung mit der Natur und bietet gleichzeitig allen Luxus und Komfort, den Sie sich wünschen können. Perfekt für diejenigen, die ein Statement setzen möchten."
      }
    },
    "specifications": {
      "ceilingHeight": "Deckenhöhe",
      "windows": "Fenster",
      "terrace": "Terrasse",
      "wallRoofInsulation": "Wand- & Dachisolierung",
      "floorInsulation": "Bodenisolierung",
      "energyRating": "Energiebewertung"
    },
    "features": {
      "energyEfficient": "Energieeffizientes Design",
      "sustainableMaterials": "Nachhaltige Materialien",
      "smartHome": "Intelligente Haustechnik",
      "openFloorPlan": "Offener Grundriss",
      "familySized": "Familienorientierter Grundriss",
      "additionalStorage": "Zusätzlicher Stauraum",
      "floorToCeiling": "Boden bis Decke reichende Fenster",
      "openConcept": "Offenes Wohnkonzept",
      "luxuryFinishes": "Luxuriöse Oberflächen",
      "indoorOutdoor": "Innen-Außen-Fluss",
      "premiumFinishes": "Premium-Oberflächen",
      "spaciousMaster": "Geräumige Master-Suite",
      "multipleLiving": "Mehrere Wohnbereiche",
      "homeOffice": "Homeoffice-Bereich",
      "designerKitchen": "Designerküche",
      "optionalDeck": "Optionale Terrassenerweiterungen",
      "ledLighting": "LED-Beleuchtung im gesamten Haus",
      "waterSaving": "Wassersparende Armaturen",
      "insulationEnergy": {
        "insulation": {
          "highQuality": "Hochwertige Isolierung"
        }
      }
    },
    "includedFeatures": {
      "title": "Was ist enthalten?",
      "headers": {
        "centralSpace": "Zentraler Raum",
        "bathroomBedrooms": "Badezimmer & Schlafzimmer",
        "outside": "Außenbereich"
      },
      "centralSpace": {
        "kitchen": "Küche mit Induktionskochfeld",
        "refrigerator": "Kühlschrank",
        "sofa": "Ausziehbares Sofa",
        "tv": "LCD-Fernseher",
        "table": "Tisch",
        "chairs": "4 Stühle"
      },
      "bathroomBedrooms": {
        "waterHeater": "Warmwasserbereiter",
        "bathroom": "Komplettes Badezimmer",
        "toilet": "Toilette",
        "shower": "Duschkabine",
        "bedBase": "Latoflex-Bettgestell",
        "mattress": "Matratze",
        "wardrobe": "Kleiderschrank und Regale"
      },
      "outside": {
        "windows": "Panoramafenster für atemberaubende Aussichten",
        "heatingCable": "Heizkabel für Außenwasseranschluss",
        "protection": "Schutz für Installationen",
        "terrace": "Terrasse (3x8m) aus verzinkten Profilen und mit Sandwichplatten bedeckt",
        "wallRoof": "Wand & Dach: 10 cm (W/mK = 0.22)",
        "decorativePanels": "Dekorative Holzplatten aus verzinktem Stahlblech"
      }
    },
    "details": {
      "bedrooms": "Schlafzimmer",
      "kitchen": "Küche",
      "bathrooms": "Badezimmer",
      "area": "Fläche",
      "terrace": "Terrasse",
      "moreSpecifications": "Weitere Spezifikationen",
      "enquireAbout": "Anfragen zu diesem Haus",
      "insulationEnergy": "Isolierung & Energieeffizienz",
      "insulation": "Isolierung",
      "energyFeatures": "Energieeffiziente Merkmale",
      "premiumFeatures": "Premium-Merkmale",
      "availableAsOption": "Als Option verfügbar",
      "floorPlans": "Grundrisse",
      "floorPlansDescription": "Entdecken Sie unsere durchdacht gestalteten Grundrisse, die auf eine Vielzahl von Lebensstilen zugeschnitten sind. Jeder Grundriss maximiert Raum, Komfort und Funktionalität und bietet die perfekte Grundlage für Ihr Traumhaus.",
      "otherModels": "Andere Hausmodelle",
      "otherModelsDescription": "Entdecken Sie unsere Kollektion von fachmännisch gefertigten modularen Häusern, die für Komfort, Stil und Flexibilität konzipiert sind. Diese Häuser sind so gebaut, dass sie zu jedem Lebensstil passen und bieten luxuriöses Wohnen mit der Freiheit, dorthin zu gehen, wohin das Leben Sie führt.",
      "garagesDescription": "Sicherer Stauraum, schlankes Design",
      "containersDescription": "Flexible, langlebige Lösungen",
      "homeGardenDescription": "Elegantes Wohnen, Outdoor-Glück"
    },
    "insulationEnergy": {
      "insulation": {
        "wallRoof": "Wand & Dach: 10cm (W/mK = 0.22)",
        "floor": "Boden: 12cm Isolierung",
        "windows": "Fenster: Ug = 1.1 W/m²K",
        "doubleGlazed": "Doppelt verglaste Fenster",
        "thermalBreak": "Wärmebrückenunterbrechung"
      },
      "energyFeatures": {
        "solarReady": "Vorbereitet für Solarpaneele",
        "ledLighting": "LED-Beleuchtung im gesamten Haus",
        "efficientAppliances": "Energieeffiziente Geräte"
      }
    },
    "premiumFeatures": {
      "panoramicWindows": "Panoramafenster für atemberaubende Aussichten",
      "flexibility": "Flexibilität und Mobilität",
      "qualityMaterials": "Hochwertige Materialien",
      "energyEfficiency": "Energieeffizienz",
      "aestheticAppeal": "Ästhetische Anziehungskraft",
      "customization": "Anpassung",
      "fastMoveIn": "Schneller Einzug",
      "idealRental": "Ideal für Vermietung",
      "lowMaintenance": "Geringe Wartungskosten",
      "privacy": "Privatsphäre und Ruhe",
      "compactDesign": "Kompaktes und geräumiges Design"
    },
    "genericModel": {
      "name": "Hausmodell",
      "description": "Modernes modulares Hausdesign.",
      "longDescription": "Dieses Modell bietet die perfekte Balance aus Komfort, Stil und Funktionalität. Mit modernem Wohnen im Sinn entworfen, verfügt es über offene Räume, hochwertige Materialien und energieeffiziente Lösungen.",
      "features": {
        "modernDesign": "Modernes Design",
        "qualityMaterials": "Hochwertige Materialien",
        "energyEfficiency": "Energieeffizienz",
        "customizableOptions": "Anpassbare Optionen"
      }
    }
  },
  "breadcrumb": {
    "home": "Startseite",
    "mobileHomes": "Mobilheime",
    "products": "Weitere Produkte",
    "about": "Über uns",
    "contact": "Kontakt",
    "blog": "Blog",
    "garages": "Garagen",
    "containers": "Container",
    "homeGarden": "Haus & Garten"
  },
  "productDetails": {
    "common": {
      "otherProducts": "Weitere Produkte",
      "otherProductsDescription": "Entdecken Sie unsere Auswahl an anpassungsfähigen Strukturen, einschließlich Garagen, Carports, Containern und Terrassen, die entworfen wurden, um jedes Haus zu ergänzen. Jedes Produkt kombiniert Haltbarkeit und Stil und schafft funktionale Räume."
    },
    "garages": {
      "loading": "Garagendetails werden geladen...",
      "error": {
        "title": "Hoppla! Etwas ist schiefgelaufen",
        "message": "Wir konnten die von Ihnen gesuchte Garage nicht finden.",
        "backButton": "Zurück zu Garagen"
      },
      "dimensions": "Abmessungen:",
      "area": "Fläche:",
      "height": "Höhe:",
      "doorWidth": "Türbreite:",
      "doorHeight": "Türhöhe:",
      "moreSpecifications": "Weitere Spezifikationen",
      "materials": "Materialien",
      "qualityMaterials": "Hochwertige Materialien",
      "additionalFeatures": "Zusätzliche Funktionen",
      "features": "Merkmale",
      "customizationOptions": "Anpassungsoptionen",
      "otherModels": "Andere Garagenmodelle",
      "otherModelsDescription": "Entdecken Sie unsere Auswahl an Garagenlösungen, die für Haltbarkeit, Funktionalität und Stil konzipiert sind. Jedes Modell bietet sicheren Stauraum für Ihre Fahrzeuge und Ausrüstung.",
      "enquireButton": "Anfragen",
      "enquireAbout": "Anfragen zu dieser Garage",
      "openGallery": "Galerie öffnen",
      "price": "Preis:"
    },
    "containers": {
      "loading": "Containerdetails werden geladen...",
      "error": {
        "title": "Hoppla! Etwas ist schiefgelaufen",
        "message": "Wir konnten den von Ihnen gesuchten Container nicht finden.",
        "backButton": "Zurück zu Containern"
      },
      "dimensions": "Abmessungen:",
      "area": "Fläche:",
      "height": "Höhe:",
      "doorWidth": "Türbreite:",
      "doorHeight": "Türhöhe:",
      "moreSpecifications": "Weitere Spezifikationen",
      "materials": "Materialien",
      "qualityMaterials": "Hochwertige Materialien",
      "additionalFeatures": "Zusätzliche Funktionen",
      "features": "Merkmale",
      "customizationOptions": "Anpassungsoptionen",
      "otherModels": "Andere Containermodelle",
      "otherModelsDescription": "Entdecken Sie unsere Auswahl an Containerlösungen, die für Vielseitigkeit, Haltbarkeit und Funktionalität konzipiert sind. Jedes Modell bietet flexiblen Raum für verschiedene Anwendungen.",
      "enquireButton": "Anfragen",
      "enquireAbout": "Anfragen zu diesem Container",
      "openGallery": "Galerie öffnen",
      "price": "Preis:"
    },
    "outdoorKitchens": {
      "loading": "Details zur Außenküche werden geladen...",
      "error": {
        "title": "Hoppla! Etwas ist schiefgelaufen",
        "message": "Wir konnten die von Ihnen gesuchte Außenküche nicht finden.",
        "backButton": "Zurück zu Außenküchen"
      },
      "dimensions": "Abmessungen:",
      "area": "Fläche:",
      "height": "Höhe:",
      "moreSpecifications": "Weitere Spezifikationen",
      "materials": "Materialien",
      "qualityMaterials": "Hochwertige Materialien",
      "additionalFeatures": "Zusätzliche Funktionen",
      "features": "Merkmale",
      "customizationOptions": "Anpassungsoptionen",
      "otherModels": "Andere Außenküchenmodelle",
      "otherModelsDescription": "Entdecken Sie unsere Auswahl an Außenküchenlösungen, die für Stil, Funktionalität und Haltbarkeit konzipiert sind. Jedes Modell bietet einen perfekten Raum zum Kochen und Unterhalten im Freien.",
      "enquireButton": "Anfragen",
      "enquireAbout": "Anfragen zu dieser Außenküche",
      "openGallery": "Galerie öffnen",
      "price": "Preis:"
    },
    "garbageBins": {
      "loading": "Details zur Mülltonne werden geladen...",
      "error": {
        "title": "Hoppla! Etwas ist schiefgelaufen",
        "message": "Wir konnten die von Ihnen gesuchte Mülltonne nicht finden.",
        "backButton": "Zurück zu Mülltonnen"
      },
      "dimensions": "Abmessungen:",
      "area": "Fläche:",
      "height": "Höhe:",
      "moreSpecifications": "Weitere Spezifikationen",
      "materials": "Materialien",
      "qualityMaterials": "Hochwertige Materialien",
      "additionalFeatures": "Zusätzliche Funktionen",
      "features": "Merkmale",
      "customizationOptions": "Anpassungsoptionen",
      "otherModels": "Andere Mülltonnenmodelle",
      "otherModelsDescription": "Entdecken Sie unsere Auswahl an Mülltonnenlösungen, die für Praktikabilität, Haltbarkeit und Stil konzipiert sind. Jedes Modell bietet effizientes Abfallmanagement und ergänzt gleichzeitig Ihr Grundstück.",
      "enquireButton": "Anfragen",
      "enquireAbout": "Anfragen zu dieser Mülltonne",
      "openGallery": "Galerie öffnen",
      "price": "Preis:"
    },
    "enquiryForm": "Anfrageformular",
    "enquiringAbout": "Sie fragen nach:",
    "generalEnquiry": "Wenn Sie eine allgemeine Anfrage einreichen möchten, klicken Sie hier."
  }
}
